import { Suspense, lazy } from 'react';
import LoadingScreen from '../components/ui/LoadingScreen';

// Lazy load sections
const Hero = lazy(() => import('../components/sections/Hero'));
const About = lazy(() => import('../components/sections/About'));
const HowItWorks = lazy(() => import('../components/sections/HowItWorks'));
const Technology = lazy(() => import('../components/sections/Technology'));
const Team = lazy(() => import('../components/sections/Team'));
const Goals = lazy(() => import('../components/sections/Goals'));
const Products = lazy(() => import('../components/sections/Products'));
const Contact = lazy(() => import('../components/sections/Contact'));

export default function Home() {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <main>
        <Hero />
        <About />
        <HowItWorks />
        <Technology />
        <Team />
        <Goals />
        <Products />
        <Contact />
      </main>
    </Suspense>
  );
}
